module.exports = __webpack_public_path__ + "static/media/pic3.e156a4b6.jpg";